import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { StoreModule } from '@ngrx/store';

import { NotificationComponent } from './components/notification/notification.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationsService } from './notifications.service';
import * as fromNotifications from './store';

export { ErrorHandlerWithNotifications } from './error-handler-with-notifications';
export { NotificationsService } from './notifications.service';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatButtonToggleModule,
    StoreModule.forFeature('notifications', fromNotifications.reducers)
  ],
  exports: [NotificationsComponent, NotificationComponent],
  providers: [NotificationsService],
  declarations: [NotificationsComponent, NotificationComponent]
})
export class NotificationsModule {}
